module.exports = __webpack_public_path__ + "static/media/smi.9cfbae28.png";